import * as actions from './actions'
import { ResourceSelected, ResourcesState } from './model'
import { ResourcesSelectorActions } from './actions'

const initialResourceDetail = {
  data: undefined,
  loading: true
};

const initialResourceSelector: ResourceSelected = {
    environment: '',
    application: '',
    apiId: '',
    versionId: '',
    dashboardType: '',
    resourceType: '',
    apiData: [],
    appData: [],
};

const initialResourceState: ResourcesState = {
    environments: {
        selected: '',
        data: [],
        loading: true
    },
    applications: {
        selected: '',
        data: [],
        loading: true
    },
    apis: {
        selected: '',
        apiSelected: '',
        data: [],
        loading: true
    },
    resourceTypeSelected: '',
    resourceDetail: initialResourceDetail,
    isLandingPageHidden: true,
    dashboardType: '',
    openedModal: false,
    resourceSelected: initialResourceSelector
};

const reducer = (state: ResourcesState = initialResourceState, action: ResourcesSelectorActions): ResourcesState => {
    switch (action.type) {
        case actions.ResourcesValues.Clear:
            return initialResourceState;
        case actions.ResourcesValues.ChangeEnv:
            return {
                ...state,
                environments: {
                    selected: '',
                    data: action.payload,
                    loading: false
                },
                applications: {
                    selected: '',
                    data: [],
                    loading: false
                },
                apis: {
                    selected: '',
                    apiSelected: '',
                    data: [],
                    loading: false
                }
            };
        case actions.ResourcesValues.ChangeApp:
            return {
                ...state,
                applications: {
                    selected: '',
                    data: action.payload,
                    loading: false
                }
            };
        case actions.ResourcesValues.ChangeApi:
            return {
                ...state,
                apis: {
                    selected: '',
                    apiSelected: '',
                    data: action.payload.data,
                    loading: action.payload.loading
                }
            };
        case actions.ResourcesValues.LoadApp:
            return {
                ...state,
                applications: {
                    ...state.applications,
                    loading: true
                }
            };
        case actions.ResourcesValues.LoadEnv:
            return {
                ...state,
                environments: {
                    ...state.environments,
                    loading: true
                }
            };
        case actions.ResourcesValues.LoadApi:
            return {
                ...state,
                apis: {
                    ...state.apis,
                    loading: true
                }
            };
        case actions.ResourcesValues.SelectEnv:
            return {
                ...state,
                environments: {
                    ...state.environments,
                    selected: action.payload
                },
                applications: {
                  selected: '',
                  data: [],
                  loading: false
                },
                apis: {
                  selected: '',
                  apiSelected: '',
                  data: [],
                  loading: false
                }
            };
        case actions.ResourcesValues.SelectApp:
          return {
                ...state,
                applications: {
                    ...state.applications,
                    selected: action.payload.appId,
                    selectedTargetId: action.payload.targetId,
                },
                apis: {
                    ...state.apis,
                    selected: '',
                    apiSelected: '',
                }
            };
        case actions.ResourcesValues.ResourceDetailsLoaded:
            return {
                ...state,
                resourceDetail: {
                  data: action.payload,
                  loading: false
                }
            };
        case actions.ResourcesValues.SelectApi:
            return {
                ...state,
                applications : {
                  ...state.applications,
                  selected: ''
                },
                apis: {
                    ...state.apis,
                  selected: '',
                  apiSelected: action.payload
                }
            };
        case actions.ResourcesValues.SelectAPIVersionId:
            return {
                ...state,
                applications : {
                  ...state.applications,
                  selected: ''
                },
                apis: {
                    ...state.apis,
                  selected: action.payload
                }
            };
        case actions.ResourcesValues.SelectDashboardType:
            return {
                ...state,
                dashboardType : action.payload
            };
        case actions.ResourcesValues.ChangeActiveLandingPage:
            return {
                ...state,
                isLandingPageHidden: action.payload
            };
        case actions.ResourcesValues.ChangeSelectedResourceType:
            return {
                ...state,
              resourceTypeSelected: action.payload,
              resourceSelected: {...state.resourceSelected, resourceType: action.payload}
            };
        case actions.ResourcesValues.HandleOpenModal:
            return {
                ...state,
                openedModal: true
            };
        case actions.ResourcesValues.HandleCloseModal:
            return {
                ...state,
                openedModal: false
            };
        case actions.ResourcesValues.SaveResourceSelector:
            return {
                ...state,
                resourceSelected: action.payload,
                resourceDetail: initialResourceDetail
            };
        default:
            return state
    }
};

export default reducer;
